import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import data from '../../data/contact';

const ContactIcons: React.FC = () => (
  <ul className="icons">
    {data.map((s) => (
      <li key={s.label}>
        <a
          href={s.link}
          aria-label={s.label}
          target={s.link.startsWith('http') ? '_blank' : undefined}
          rel={s.link.startsWith('http') ? 'noopener noreferrer' : undefined}
        >
          {/* eslint-disable-next-line @typescript-eslint/no-unsafe-assignment */}
          <FontAwesomeIcon icon={s.icon} />
        </a>
      </li>
    ))}
  </ul>
);

export default ContactIcons;
